<template>
  <div class="">
    <el-dialog title="查看详情"
               width="900px"
               :visible.sync="visibleValue"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :modal-append-to-body="true"
               :append-to-body="true"
               @closed="closedCallback">
      <el-form inline size="small">
        <el-form-item label="起运城市">
          <el-select v-model="searchData.cityId"
                     clearable
                     filterable
                     @change="changeCity"
                     class="input-width"
          >
            <el-option
              v-for="(item, index) in startCityList"
              :key="index"
              :label="item.cityName"
              :value="item.cityId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="海外仓">
          <el-select v-model="searchData.warehouseId"
                     clearable
                     filterable
                     :disabled="!searchData.cityId"
                     class="input-width">
            <el-option
              v-for="(item, index) in overseasWarehouseList"
              :key="index"
              :label="item.overseasWarehouseName"
              :value="item.overseasWarehouseId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="派送方式">
          <el-select v-model="searchData.deliveryType"
                     clearable
                     filterable
                     class="input-width">
            <el-option
              v-for="(item, index) in deliveryTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary"
                     @click="clickSearch"
                     style="width: 100px;">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="list"
        style="width: 100%"
        :header-cell-style="{ background: '#F3F3F3' }"
        size="small"
      >
        <el-table-column label="序号" type="index" width="50"/>
        <el-table-column label="报价名称" property="quotedName" min-width="200"/>
        <el-table-column label="起运城市" property="cityName" min-width="120"/>
        <el-table-column label="海外仓" property="warehouseName" min-width="120"/>
        <el-table-column label="派送方式" property="" width="120">
          <template slot-scope="scope">
            {{ deliveryTypeListMapObject[scope.row.deliveryType] || scope.row.deliveryType || "" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" property="" width="120">
          <template slot-scope="scope">
            <el-link
              @click="showQuotation(scope.row,scope.$index)"
              type="primary"
              :underline="false">
              查看报价
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 20px;">
        <el-button style="width: 120px;" size="small" @click="closedDialog">关闭</el-button>
      </div>
    </el-dialog>
    <use-platform-quotation-view-quotation
      :visible.sync="visibleQuotation"
      :id="viewQuotationId"
      @closed="hideQuotation"
    />
  </div>
</template>

<script>
import {mixinsDialog} from "my-element-mixins";
import UsePlatformQuotationViewQuotation
  from "@/components/QuotationManagement/components-productQuotation/usePlatformQuotation/viewQuotation";
import {isObject} from "my-tools-kit";
import {mapFromArrayToObject} from "@/assets/js/utils";

let deliveryTypeList = [
  { label: '全部', value: '' },
  { label: '卡派', value: 'KP' },
  { label: '海卡', value: 'HK' },
  { label: '海派', value: 'HP' },
  { label: '整柜直送', value: 'WC' },
  { label: '空派', value: 'FP' },
  { label: '空卡', value: 'KK' },
];
export default {
  name: "usePlatformQuotationSupplierDetails",
  components: {UsePlatformQuotationViewQuotation},
  mixins:[mixinsDialog],
  props:{
    countryId:[Number,String],//国家id
    carrierId:[Number,String],//供应商id
  },
  data(){
    return {
      /* 筛选 */
      searchData:{
        cityId:"",//起运城市
        warehouseId:"",//海外仓
        deliveryType:"",//派送方式
      },
      startCityList:[
        { cityName: '全部', cityId: '' },
      ],//起运城市列表
      loadingStartCity:false,
      overseasWarehouseList:[
        { overseasWarehouseName: '全部', overseasWarehouseId: '' },
      ],//海外仓列表
      loadingOverseasWarehouse:false,
      deliveryTypeList: deliveryTypeList,//派送方式
      deliveryTypeListMapObject:mapFromArrayToObject(deliveryTypeList),

      // 列表
      loadingList:false,
      list:[],
      /* 查看报价 */
      visibleQuotation:false,
      viewQuotationId:"",
    }
  },
  methods:{
    /**
     * 关闭回调
     */
    closedCallback() {
      this.$emit('closed');
      this.resetData();
    },
    /**
     * 重置数据
     */
    resetData(){
      this.loadingList = false;
      this.list = [];

      this.searchData = {
        cityId: "",//起运城市
        warehouseId: "",//海外仓
        deliveryType: "",//派送方式
      };

      this.loadingOverseasWarehouse = false;
      this.overseasWarehouseList = [
        { overseasWarehouseName: '全部', overseasWarehouseId: '' }
      ];

      this.loadingStartCity = false;
      this.startCityList = [{ cityName: '全部', cityId: '' }];

      this.viewQuotationId = "";
      this.visibleQuotation = false;

    },
    /**
     * 初始化
     */
    init(){
      this.$nextTick(()=>{
        this.getList();
        this.getStartCityList();
      })
    },
    /**
     * 切换起运城市
     * @param value
     */
    changeCity(value){
      this.searchData.warehouseId = "";
      if(value){
        this.getOverseasWarehouseList();
      }
    },
    /**
     * 点击查询
     */
    clickSearch(){
      if(!this.countryId) return this.$message("缺少 国家id");
      if(!this.carrierId) return this.$message("缺少 供应商id");
      // if(!this.deliveryType) return this.$message("缺少 派送方式");
      // if(!this.overseasWarehouseCityId) return this.$message("缺少 起运城市Id");
      // if(!this.overseasWarehouseId) return this.$message("缺少 海外仓库Id");
      this.getList();
    },
    /**
     * 获取列表
     */
    getList(){
      let url = `/api/smartQuotedPrice/getQuotedWarehouseInfo`;
      let data = {
        "carrierId": this.carrierId,//供应商id
        "countryId": this.countryId,
        "deliveryType": this.searchData.deliveryType,//派送方式（KP 卡派 HP 海派）
        "overseasWarehouseCityId": this.searchData.cityId,//起运城市Id
        "overseasWarehouseId": this.searchData.warehouseId,//海外仓库Id
      };
      this.loadingList = true;
      this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loadingList = false;
          let list = res.datas || [];
          this.list = list;
        })
        .catch(res=>{
          this.loadingList = false;
          this.list = [];
        })
    },
    /**
     * 获取海外仓城市列表
     */
    getStartCityList(){
      let url = `/api/supplierBaseOverseasWarehouse/getOverseasWarehouseCityList`;
      let data = {
        "carrierId": this.carrierId,
        "countryId": this.countryId,
      };
      this.loadingStartCity = true;
      this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loadingStartCity = false;
          let list = res.datas || [];
          list.unshift({ cityName: '全部', cityId: '' });
          this.startCityList = list;
        })
        .catch(res=>{
          this.loadingStartCity = false;
          this.startCityList = [{ cityName: '全部', cityId: '' }];
        })
    },
    /**
     * 获取海外仓列表
     */
    getOverseasWarehouseList(){
      let url = `/api/supplierBaseOverseasWarehouse/getOverseasWarehouseList`;
      let data = {
        "carrierId": this.carrierId,
        "countryId": this.countryId,
        "cityId": this.searchData.cityId,
      };
      this.loadingOverseasWarehouse = true;
      this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loadingOverseasWarehouse = false;
          let list = res.datas || [];
          list.unshift({ overseasWarehouseName: '全部', overseasWarehouseId: '' });
          this.overseasWarehouseList = list;
        })
        .catch(res=>{
          this.loadingOverseasWarehouse = false;
          this.overseasWarehouseList = [
            { overseasWarehouseName: '全部', overseasWarehouseId: '' }
          ];
        })
    },
    /**
     * 查看报价
     */
    showQuotation(item,index){
      this.viewQuotationId = item.id;
      this.visibleQuotation = true;
    },
    hideQuotation(){
      this.viewQuotationId = "";
      this.visibleQuotation = false;
    },
  },
}
</script>

<style scoped lang="scss">
.input-width{
  width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/usePlatformQuotation/viewSupplierDetails.vue